import { formatDate } from "@/utils/dateUtil"

import { User } from "../User"
import { Notification } from "./Notification"

export class NotificationTimesheet extends Notification {
  constructor(props) {
    super(props)
  }

  get initiator() {
    return this.content.initiator ? User.create(this.content.initiator) : User.createDefault()
  }

  get startDate() {
    return this.content.startDate
      ? formatDate(this.content.startDate, "dd MMM", { dateOnly: true })
      : ""
  }

  get endDate() {
    return this.content.endDate
      ? formatDate(this.content.endDate, "dd MMM", { dateOnly: true })
      : ""
  }

  get accountName() {
    return this.content.accountName || ""
  }

  get declineReason() {
    return this.content.declineReason || ""
  }
}
